import { Component, AfterViewInit } from '@angular/core';
import { LoaderService } from '../../core/service/loader/loader.service';



@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements AfterViewInit {

  constructor(
    private loaderService: LoaderService
  ) { }

  ngAfterViewInit(): void {
    this.loaderService.showLoader();
    // Inizializza particlesJS dopo che la vista è completamente pronta
    if (window.particlesJS) {
      window.particlesJS('tsparticles1', {
        particles: {
          number: { value: 100 },
          color: { value: '#fff' },
          line_linked: { enable: true, color: '#fff' },
          move: { enable: true, speed: 6 }
        }
      });

      setTimeout(() => {
        this.loaderService.hideLoader();
      }, 1000); // tempo che permette l'inizializzazione dell'animazione
    }
  }
}
